import { Button, Flex, Selector, SelectionOption } from '@/components'
import { TagsList, TagsListItem } from '@/components/core/TagsList/TagsList.component'
import { BaseModal } from '@/components/shared/Modal/Modal.component'
import { CompanyWithUsersResponse } from '@shared/models'
import { useState } from 'react'

function formatDate(value: string): string {
  const date = new Date(value)
  const day = String(date.getUTCDate()).padStart(2, '0')
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const year = date.getUTCFullYear()
  return `${day}/${month}/${year}`
}

type EditStaffCompanyModalProps = {
  company: CompanyWithUsersResponse | null
  userOptions: SelectionOption[]
  onClose: () => void
  onRemoveUser: (userID: string, companyID: string) => void
  onAddUser: (userID: string, companyID: string) => void
}

export function EditStaffCompanyModal({
  company,
  userOptions,
  onClose,
  onRemoveUser,
  onAddUser,
}: EditStaffCompanyModalProps) {
  const [userSearchTerm, setUserSearchTerm] = useState('')

  if (!company) return null

  const availableUserOptions = userOptions.filter(
    (user) =>
      !company.users.some((linked) => linked.userID === user.value) &&
      user.text.toLowerCase().includes(userSearchTerm.toLowerCase()),
  )

  function handleAddUser(option?: SelectionOption): void {
    if (!company || !option) return
    onAddUser(String(option.value), company.companyID)
    setUserSearchTerm('')
  }

  return (
    <BaseModal isOpen={!!company} onClose={onClose} title={`Editar ${company.companyName}`} maxWidth="720px">
      <Flex $type="column" $align="stretch" $gap={24}>
        <Selector.Searchable
          label="Adicionar usuário"
          placeholder="Buscar usuário para vincular"
          options={availableUserOptions}
          onSelect={handleAddUser}
          onSearch={setUserSearchTerm}
        />
        <Flex $type="column" $align="stretch" $gap={8}>
          <span>Usuários vinculados</span>
          <TagsList
            emptyText="Nenhum usuário vinculado"
            maxVisible={company.users.length || 1}
            fullText
            tags={company.users.map(
              (user): TagsListItem => ({
                id: user.userID,
                text: user.userName,
                removable: !user.isAdmin,
                tooltip:
                  user.isAdmin ? 'Acesso por ser Administrador'
                  : user.linkedDate ? `Vinculado em ${formatDate(user.linkedDate)}`
                  : undefined,
              }),
            )}
            onRemove={(tag) => onRemoveUser(tag.id, company.companyID)}
          />
        </Flex>
        <Flex $type="row" $justify="flex-end" $align="center" $gap={16}>
          <Button.Root $variant="secondary" onClick={onClose}>
            <Button.Text value="Fechar" />
          </Button.Root>
        </Flex>
      </Flex>
    </BaseModal>
  )
}
